export default {
  TYPE_SESSION_FOR_ALL_USER: 'session_for_all_user',
  TYPE_ALL_SESSION_OF_USER: 'all_session_of_user',
  TYPE_DATE_FOR_USER: 'session_for_user',
};
